import { render } from "./FileNodeDetail.vue?vue&type=template&id=23e528fa&ts=true"
import script from "./FileNodeDetail.vue?vue&type=script&lang=ts"
export * from "./FileNodeDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__